import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useCompanyClientData(companyId?: number) {
    const { data: clientOptions, isPending: isPendingClientOptions } = useQuery({
        queryKey: ['all-company-clients', companyId],
        queryFn: async () => {
            const { data } = await axios.get(
                route('v2.companies.all-company-clients.get', companyId),
            );
            return data;
        },
        enabled: !!companyId,
        placeholderData: [],
    });

    return {
        clientOptions,
        isPendingClientOptions,
    };
}
